module.exports = __webpack_public_path__ + "static/media/add-icon-blue.ee5791fe.svg";